<template>
  <div>
    <Loading ref="loading"></Loading>
    <Drawer
      class="select-role"
      :open="isOpen"
      title="绑定角色"
      show-close
      close-text="跳过"
      @close="onClose"
    >
      <div class="wrapper">
        <div class="role-list">
          <div
            @click="handleRoleSelect(role.role_id)"
            class="role"
            v-for="role in roleList"
            :key="role.role_id"
          >
            <div class="info">
              <div class="name">{{ role.role_name }}</div>
              <div class="sub-info">
                <div>{{ role.server_name }}</div>
                <div>{{ role.grade }}</div>
              </div>
            </div>
            <div
              class="select"
              :value="role.role_id"
              :class="current === role.role_id ? 'checked' : ''"
            >
              <img src="@/assets/check.png" />
            </div>
          </div>
        </div>
        <Button @click="handleBind" class="btn-bind" width="23rem" height="3rem"
          >绑定角色</Button
        >
      </div>
    </Drawer>
  </div>
</template>

<script>
import Button from "@/components/button/index.vue";
import Drawer from "@/components/drawer/index.vue";
import Loading from "@/components/loading/index.vue";
import qs from "qs";
export default {
  emits: ["close", "select"],
  components: {
    Drawer,
    Button,
    Loading,
  },
  data() {
    return {
      isOpen: false,
      current: this.$props.default,
      roleId: 1,
      roleList: [],
    };
  },
  props: {
    default: {
      type: [String, Number],
    },
  },
  methods: {
    createHeader: function () {
      let header = {
        pf_source: "miniprogram-community",
        version: "1.0.0",
        // attach_info: Buffer.from(JSON.stringify({ fid: 2, app_id: 102095, cch_id: 1038 }), 'utf8').toString('base64'),
        nonce: this.$xh.nonce(),
        ts: Date.now(),
      };
      // appkey => 1pl888na2bmupih9ciiPDKVCkgKoeEehSuNknw==
      // header.sign = RSSign(header, Decrypt('1pl888na2bmupih9ciiPDKVCkgKoeEehSuNknw=='))
      header.sign = this.$RSSign(header, this.$xh.xhParams.gameCenterKey);
      return Buffer.from(qs.stringify(header), "utf8").toString("base64");
    },
    getWxUser({ papp_id, app_type, app_id }) {
      if (app_type === "sy") return Promise.resolve(null);
      return new Promise((resolve, reject) => {
        const params = {
          app_id,
          tm: Date.now(),
          nonce: this.$xh.nonce(),
          version: this.$xh.xhParams.version,
          sign_type: "md5",
          con_id: this.$xh.xhParams.con_id,
          papp_id,
          app_type,
        };
        params.sign = this.$RSSign(params, this.$xh.xhParams.key);
        this.$ajax({
          method: "get",
          url: this.$api.v2.getWxUser,
          params,
        })
          .then((res) => {
            if (res.data.code === 200 && res.data.data) {
              resolve(res.data.data);
            } else {
              resolve(null);
            }
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    loadRoleList(game) {
      const loadingList = [];
      this.roleList = [];

      this.$refs.loading.show("正在获取角色列表...");
      game.app_list.forEach((item) => {
        if (!item.is_search) return;
        loadingList.push(
          this.getWxUser({ ...game, ...item })
            .then((info) => {
              const params = {
                ts: Date.now(),
                nonce: this.$xh.nonce(),
                version: this.$xh.xhParams.version,
                sign_type: "md5",
                app_id: item.app_id,
                cch_id: item.cch_id,
                game_type: game.app_type,
              };
              if (info?.openid) params.openid = info.openid;
              params.sign = this.$RSSign(
                params,
                this.$xh.xhParams.gameCenterKey
              );
              return this.$ajax({
                method: "get",
                url: this.$api.v2.roleList,
                params,
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "Client-Biz-Info": this.createHeader(),
                },
              });
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.roleList.push(
                  ...res.data.data.role_list.map((r) => {
                    return {
                      ...r,
                      app_id: item.app_id,
                      cch_id: item.cch_id,
                    };
                  })
                );
              } else {
                return null;
              }
            })
            .catch(() => {
              this.$toast("网络异常，请刷新重试");
            })
        );
      });

      console.log(loadingList);

      Promise.allSettled(loadingList).then(() => {
        this.$refs.loading.hide();
      });
    },
    open(game) {
      this.isOpen = true;
      this.loadRoleList(game);
    },
    onClose() {
      this.isOpen = false;
      this.$emit("close");
    },
    handleRoleSelect(id) {
      this.current = id;
    },
    handleBind() {
      if (!this.current) return;
      this.isOpen = false;
      this.$emit(
        "select",
        this.roleList.find((item) => item.role_id === this.current)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/color.scss";
.select-role {
  :deep(.outer) {
    .drawer {
      padding: 0 0 1rem 0;
    }
  }

  .role-list {
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    min-height: 5rem;
    max-height: calc(60vh);
    padding: 1rem;
    box-sizing: border-box;
    overflow: scroll;
    .role {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      background: rgb(240, 240, 240);
      border-radius: 0.8rem;
      padding: 0.5rem 1.2rem;
      box-sizing: border-box;
      height: 5rem;
      .info {
        display: flex;
        flex-direction: column;
        gap: 5px;
        color: #777;
        .name {
          font-size: 1.5rem;
        }
        .sub-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          gap: 3rem;
        }
      }
      .select {
        all: initial;
        height: 1.5rem;
        width: 1.5rem;
        border-radius: 1.5rem;
        background: rgb(181, 181, 181);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          height: 1.2rem;
          width: 1.2rem;
        }
        &.checked {
          background: rgb(242, 59, 77);
        }
      }
    }
  }
  .btn-bind {
    margin-top: 2rem;
    font-size: 1.2rem;
  }
  .wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
